<div class="card mt-5">
  <div class="row no-gutters">
    <div class="col-md-4 custom-logo">
      <i class="fa fa-file-image-o"></i>
      <div class="card-body">
        LOGO IOFE S.A.C.
      </div>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title">IOFE S.A.C</h5>
        <h6 class="card-text">SOMOS UNA EMPRESA 100% PERUANA ACREDITADA POR INDECOPI QUE OFRECE EXCLUSIVAMENTE
          SOLUCIONES EN UN ENTORNO DIGITAL SEGURO.</h6>
        <p class="card-text"><small class="text-muted">Visítanos :<a href="https://iofesac.com">https://iofesac.com</a></small>
        </p>
      </div>
    </div>
  </div>
</div>
